import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Typography from '@segment/matcha/components/Typography'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'
import RichText from '@segment/matcha/recipes/RichText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import type { EventCard } from '@segment/api/routes/customerSuccessEvent/queries'

const copy = {
  heading: `Past Webinar Recordings`,
}

interface PastWebinarsProps {
  data: EventCard[]
}

const PastWebinars: FC<PropsWithChildren<PastWebinarsProps>> = ({ data }) => {
  return (
    <SectionBase variant="centered" id="past-webinars">
      <Section.Copy>
        <Typography variant="h2" tag="h2">
          {copy.heading}
        </Typography>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          columns={1}
          overrides={{
            lg: 3,
          }}
        >
          {data.map(({ eventType, title, content, ctaText, url, image }, key) => (
            <CardBase href={url} key={key}>
              {image && <Card.Image alt="" src={image?.fields.file.url} variant="fill" />}
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <Card.Label>{eventType}</Card.Label>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline tag="h3">{title}</Card.Headline>
                  <Card.Description tag="div">
                    <RichText data={content as RichTextDocument} />
                  </Card.Description>
                </Card.Copy>
                <Card.Action alignment="left">
                  <ButtonText iconEnd={ChevronRightIcon}>{ctaText}</ButtonText>
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default PastWebinars
